/**
 * A model for an individual corporate employee
 */
export class dashboardList {
    Id:number;
    contactEmail: string;
    faultDescription: string;
    mag: string;
    modelNumber:string;
    serialNumber: string;

    constructor(Id:number,contactEmail:string,faultDescription: string,mag: string,modelNumber: string,serialNumber: string){
        this.Id=Id;
        this.contactEmail = contactEmail;
        this.faultDescription = faultDescription;
        this.mag = mag;
        this.modelNumber = modelNumber;
        this.serialNumber = serialNumber;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb_dashboard/datatable/dashboardList.ts